import {
    useMemo,
} from 'react'

import ChipSelect from 'app/shared-components/ChipSelect'
import useGetUsers from 'app/Apps/ContactManagement/Users/hooks/useGetUsers'
import {
    NotificationIconProps,
} from '../NotificationIcon/notificationIcon.types'

type Props = {
    value?: { id: number }[],
    onChange: (newValue: { id: number }[]) => void
    title?: string,
    disabled?: boolean,
    required?: boolean,
    notificationIconProps?: NotificationIconProps,
    availableUsersIds: number[],
}
const defaultProps: Partial<Props> = {
    value: [],
    title: 'Users',
    disabled: false,
    required: false,
    notificationIconProps: undefined,
}
const MultipleUserChipSelect = ({
    value,
    title,
    onChange,
    disabled,
    required,
    notificationIconProps,
    availableUsersIds,
}: Props) => {
    const {
        data: users,
    } = useGetUsers(availableUsersIds)

    const options: {
        value: number,
        label: string,
    }[] = useMemo(() => {
        return users?.map((item) => {
            return {
                value: item.id,
                label: item.userName,
            }
        })
    }, [users])

    const selectedItems = useMemo(() => {
        if (!value || !users?.length) return []

        return value.map((item) => {
            return {
                value: item.id,
                label: users?.find((user) => {
                    return user.id === item.id
                })?.userName || '',
            }
        })
    }, [
        users,
        value,
    ])

    const handleOnChange = (newValue: { value: number, label: string }[]) => {
        onChange(newValue ? newValue.map((item) => {
            return {
                id: item.value,
            }
        }) : [])
    }

    return (
        <ChipSelect
            disabled={disabled}
            required={required}
            notificationIconProps={notificationIconProps}
            options={options}
            title={title}
            value={selectedItems}
            onChange={handleOnChange}
            defaultDropdownPlaceholder="No options"
        />
    )
}

MultipleUserChipSelect.defaultProps = defaultProps

export default MultipleUserChipSelect
